"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  cutTime: {
    vesselAndVoyage: 'Vessel&Voyage',
    startTime: 'Start date',
    endTime: 'End Time',
    form: 'To',
    pol: 'POL',
    port: 'Port',
    etdNotNull: 'ETD not null',
    vesselAndVoyageNotNull: 'Vessel&Voyage not null',
    vesselAndVoyageOrEtdNotNull: 'VVL、ETD At least one cannot be empty',
    etdBetween: 'No more than 68 days',
    dgDeadlineTime: 'DG DEADLINE TIME',
    frCutOffTime: 'RF CUT OFF TIME',
    akCutOffTime: 'AK CUT OFF TIME',
    cutVgmDate: 'VGM CUT OFF TIME'
  },
  cutTimeTable: {
    vesselCode: "VESSEL CODE",
    voy: "VOY",
    leg: "LEG",
    portCode: "PORT CODE",
    etd: 'ETD',
    sailingDate: "SAILING DATE",
    docCutTime: "DOC CUT TIME",
    cyCutTime: "CY CUT TIME",
    dgDeadlineTime: 'DG DEADLINE TIME',
    frCutOffTime: 'RF CUT OFF TIME',
    akCutOffTime: 'AK CUT OFF TIME',
    ladenOnBoard: 'Laden Onboard'
  }
};